import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlJson } from '../ControlJson'

import { control } from './control'

/**
 * @param {string} name
 * @param {*} value
 * @param {Object} defaultProps
 */
export function json(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlJson, defaultProps)
}
